import React from "react";

import Entities from "../../components/Entities";

function Promotions() {
  return (
    <Entities
      shema={{
        fields: [{ name: "Name", propertyName: "name", search: true }],
      }}
    />
  );
}

export default Promotions;
